export type ToastType = 'success' | 'danger' | 'info' | 'warning'

export interface ToastItem {
  id: string
  title?: string
  message: string
  type: ToastType
  duration: number
}

interface AddNotificationOptions {
  title?: string
  message: string
  type: ToastType
  container?: string
  insert?: string
  animationIn?: string[]
  animationOut?: string[]
  dismiss?: {
    duration?: number
    onScreen?: boolean
  }
  [key: string]: unknown
}

type AddListener = (item: ToastItem) => void
type RemoveListener = (id: string) => void

const addListeners: AddListener[] = []
const removeListeners: RemoveListener[] = []

export const Store = {
  addNotification(options: AddNotificationOptions) {
    const item: ToastItem = {
      id: Math.random().toString(36).slice(2) + Date.now(),
      title: options.title,
      message: options.message,
      type: options.type,
      duration: options.dismiss?.duration ?? 3000,
    }
    addListeners.forEach((fn) => fn(item))
  },

  _onAdd(fn: AddListener) {
    addListeners.push(fn)
    return () => {
      const idx = addListeners.indexOf(fn)
      if (idx !== -1) addListeners.splice(idx, 1)
    }
  },

  _onRemove(fn: RemoveListener) {
    removeListeners.push(fn)
    return () => {
      const idx = removeListeners.indexOf(fn)
      if (idx !== -1) removeListeners.splice(idx, 1)
    }
  },

  _remove(id: string) {
    removeListeners.forEach((fn) => fn(id))
  },
}
